// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function VarietiesText({ wine, icon = null, ...rest }) {
  const varieties = wine?.grapeVarieties
    .map(
      ({ percentage, varietyName }) =>
        `${percentage ? `${percentage}% ` : ''} ${varietyName}`
    )
    .join(', ');
  if (!varieties) return null;

  return (
    <Text variant="smallest" sx={{ color: 'text' }} {...rest}>
      {icon}
      {varieties}
    </Text>
  );
}

export const fragment = graphql`
  fragment VarietiesText on Wine {
    grapeVarieties {
      varietyName
      percentage
    }
  }
`;

VarietiesText.fragment = gql`
  fragment VarietiesText on Wine {
    grapeVarieties {
      varietyName
      percentage
    }
  }
`;
